module.exports = __webpack_public_path__ + "static/media/zhuwei_bg.d44ab400.png";